import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const ethnicityDescriptor = defineListFilter({
  definition: {
    id: FilterId.ETHNICITY,
    name: 'Ethnicity',
    selectionListId: 'ethnicity',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_ETHNICITY },
});
